import { render } from "./Create.vue?vue&type=template&id=39d143ac&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=39d143ac&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=39d143ac&lang=css"

import exportComponent from "/home/dyam/Documentos/RAREZA/mi-stock-rareza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d143ac"]])

export default __exports__